import Vue from 'vue'
import VAd4  from './ad4'

export default VAd4




// WEBPACK FOOTER //
// ./src/components/index/mobile/ad4/index.js